import { fetch, isJsonResponse } from '@zapier/toolbox-browser-fetch';

import {
  forgotPasswordResult,
  loginResult,
  resetPasswordResult,
  twoFactorResult,
} from './LoginUtils';

const catchErrorToLegacyResponse = promise =>
  promise.catch(response => {
    if (!response || !response.status || typeof response.text !== 'function') {
      throw response;
    }
    return response.text().then(body => {
      // This is because displaying errors currently relies on this legacy
      // property.
      response.responseText = body;
      throw response;
    });
  });

const Data = {
  login(email, password, accountId) {
    // We need account id here so that in case that email address
    // belongs to a SAML and non-SAML account
    const data = { account_id: accountId, email, password };

    return fetch('/api/v3/login', {
      method: 'POST',
      body: JSON.stringify(data),
    }).then(response => {
      if (!isJsonResponse(response)) {
        // if missing CSRF token, server returns 403 with HTML response body
        return {
          type: loginResult(response, {}),
          details: {},
        };
      }
      return response.json().then(json => {
        // Stupid dumb hack because you can't read the body twice.
        response.responseText = JSON.stringify(json);
        return {
          type: loginResult(response, json),
          details: json,
        };
      });
    });
  },

  logout() {
    return fetch('/api/logout/');
  },

  confirm2FACode(type, code) {
    return catchErrorToLegacyResponse(
      fetch('/api/v3/2fa', {
        method: 'POST',
        body: JSON.stringify({ [type]: code }),
      }).then(response => {
        return twoFactorResult(response);
      })
    );
  },

  confirmSecureSession() {
    return catchErrorToLegacyResponse(
      fetch('/api/v3/secure-session', {
        method: 'POST',
        body: JSON.stringify({}),
      }).then(response => {
        return twoFactorResult(response);
      })
    );
  },

  forgotPassword(email) {
    const data = { email };

    return catchErrorToLegacyResponse(
      fetch('/api/v3/accounts/password/forgot', {
        method: 'POST',
        body: JSON.stringify(data),
      }).then(response => {
        return forgotPasswordResult(response);
      })
    );
  },

  resetPassword(username, code, password1, password2) {
    const data = {
      username,
      code,
      password1,
      password2,
    };

    return catchErrorToLegacyResponse(
      fetch('/api/v3/accounts/password/reset', {
        method: 'POST',
        body: JSON.stringify(data),
      }).then(response => {
        return response.json().then(json => {
          const resultType = resetPasswordResult(response);
          return {
            resultType,
            errors: json.errors,
          };
        });
      })
    );
  },
};

export default Data;
